import { path } from 'ramda';

import { FEATURE_NAME as $, CURRENT, FILTERS } from './consts';

export const getWriting = path([$, CURRENT]);
export const getWritingProp = (name) => path([$, CURRENT, name]);
export const getFilters = path([$, FILTERS]);
export const getFilter = (name) => path([$, FILTERS, name]);
